
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../../../src/assets/scss/Profile.module.scss';
import { BaseURL } from '../../lib/api';
import { toast } from 'react-toastify';
import Logo from '../../assets/images/cropLogo.png';


const UserProfile = () => {
    const location = useLocation();

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        userName: '',
        password: '',
        confirmPassword: '',
        userType: '',
        personalAddress: '',
        address2: '',
        pincode: '',
        city: '',
        state: '',
        organizationName: '',
        gst: '',
        paymentDetails: 'Bank Account',
        bankName: '',
        bankAccount: '',
        confirmBankAccount: '',
        bankIfsc: '',
        upiId: '',
        profileFile: null,
    });


    const [errors, setErrors] = useState({});
    //const [profileImage, setProfileImage] = useState('https://i.pravatar.cc/100?img=3');
    const [profileImage, setProfileImage] = useState('');
    const [inviteToken, setInviteToken] = useState('');



    useEffect(() => {
        const tokenFromState = location.state?.token;
        const typeFromState = location.state?.type;

        const queryParams = new URLSearchParams(location.search);
        const tokenFromQuery = queryParams.get('token');
        const typeFromQuery = queryParams.get('type');

        const finalToken = tokenFromState || tokenFromQuery;
        const finalType = typeFromState || typeFromQuery;

        if (finalToken) {
            localStorage.setItem('inviteToken', finalToken);
            setInviteToken(finalToken);
        }

        if (finalType) {
            setFormData((prev) => ({ ...prev, userType: finalType }));
        }
    }, [location]);


    const handleChange = (e) => {
        const { name, value } = e.target;

        if ((name === 'firstName' || name === 'lastName') && /[^a-zA-Z\s]/.test(value)) return;
        if (name === 'phone') {
            if (!/^\d*$/.test(value)) return;
            if (value.length > 10) return;
            if (value.length === 1 && !/^[6-9]$/.test(value)) return;
        }

        setFormData((prev) => ({ ...prev, [name]: value }));
    };
    const validate = () => {
        const newErrors = {};
        // const requiredFields = [
        //     'firstName', 'lastName', 'email', 'phone', 'userName', 'password', 'confirmPassword',
        //     'personalAddress', 'address2', 'pincode', 'city', 'state',
        //     'organizationName', 'bankName', 'bankAccount', 'confirmBankAccount', 'bankIfsc', 'upiId'
        // ];

        // const requiredFields = [
        //     'firstName', 'lastName', 'email', 'phone', 'userName', 'password', 'confirmPassword',
        //     'bankName', 'bankAccount', 'confirmBankAccount', 'bankIfsc', 'upiId'
        // ];

        const requiredFields = [
            'firstName', 'lastName', 'email', 'phone', 'userName', 'password', 'confirmPassword'
        ];


        if (formData.userType !== 'employee') {
            requiredFields.push('personalAddress', 'address2', 'pincode', 'city', 'state', 'organizationName');
        }


        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = 'This field is required';
            }
        });

        if (formData.phone && !/^[6-9]\d{9}$/.test(formData.phone)) {
            newErrors.phone = 'Phone number must start with 6-9 and be exactly 10 digits';
        }

        if (formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match';
        }

        if (!/^(?=.*[!@#$%^&*()\-_=+{};:,<.>]).{10,}$/.test(formData.password)) {
            newErrors.password = 'Password must be at least 10 characters and include one special character';
        }

        if (formData.bankAccount !== formData.confirmBankAccount) {
            newErrors.confirmBankAccount = 'Bank Account numbers do not match';
        }

        return newErrors;
    };


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                setProfileImage(reader.result);
            };
            reader.readAsDataURL(file);

            setFormData((prev) => ({
                ...prev,
                profileFile: file,
            }));
        }
    };
    const navigate = useNavigate();

    const [orgLogoFile, setOrgLogoFile] = useState(null);
    const [orgLogoPreview, setOrgLogoPreview] = useState(null);

    const handleOrgLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setOrgLogoFile(file);
            setOrgLogoPreview(URL.createObjectURL(file));
        }
    };




    // const handleSubmit = async () => {
    //     const validationErrors = validate();
    //     setErrors(validationErrors);

    //     if (Object.keys(validationErrors).length === 0) {
    //         const form = new FormData();
    //         form.append('firstName', formData.firstName);
    //         form.append('lastName', formData.lastName);
    //         form.append('userName', formData.userName);
    //         form.append('email', formData.email);
    //         form.append('password', formData.password);
    //         form.append('phone', formData.phone);

    //         if (formData.userType !== 'employee') {
    //             form.append('storeName', formData.organizationName);
    //             form.append('address1', formData.personalAddress);
    //             form.append('address2', formData.address2);
    //             form.append('pincode', formData.pincode);
    //             form.append('city', formData.city);
    //             form.append('state', formData.state);
    //             form.append('gst', formData.gst);
    //         }

    //         form.append('bankName', formData.bankName);
    //         form.append('accountNo', formData.bankAccount);
    //         form.append('ifsc', formData.bankIfsc);
    //         form.append('paymentType', formData.paymentDetails === 'Bank Account' ? 'bank' : 'upi');
    //         form.append('upiId', formData.upiId);

    //         if (formData.profileFile) {
    //             form.append('profile', formData.profileFile);
    //         }
    //         if (orgLogoFile && formData.userType !== 'employee') {
    //             form.append('logo', orgLogoFile);
    //         }

    //         try {
    //             const response = await axios.post(`${BaseURL}/invite/createUser`, form, {
    //                 headers: {
    //                     'Content-Type': 'multipart/form-data',
    //                     'inviteToken': inviteToken,
    //                 },
    //             });

    //             const { message, user } = response.data;

    //             toast.success(message || 'Registration successful!');

    //             localStorage.setItem('userId', user._id);
    //             localStorage.setItem('userType', user.type);
    //             localStorage.setItem('userName', user.userName);
    //             localStorage.setItem('email', user.email);

    //             setTimeout(() => {
    //                 navigate('/');
    //             }, 3000);
    //         } catch (error) {
    //             const errorMessage = error.response?.data?.message || 'Submission failed';
    //             toast.error(errorMessage);
    //         }
    //     }
    // };


    const handleSubmit = async () => {
        const validationErrors = validate();
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length === 0) {
            const form = new FormData();
            form.append('firstName', formData.firstName);
            form.append('lastName', formData.lastName);
            form.append('userName', formData.userName);
            form.append('email', formData.email);
            form.append('password', formData.password);
            form.append('phone', formData.phone);

            if (formData.userType !== 'employee') {
                form.append('storeName', formData.organizationName);
                form.append('address1', formData.personalAddress);
                form.append('address2', formData.address2);
                form.append('pincode', formData.pincode);
                form.append('city', formData.city);
                form.append('state', formData.state);
                form.append('gst', formData.gst);
            }

            // ✅ Append payment info only if filled
            if (formData.paymentDetails) {
                form.append('paymentType', formData.paymentDetails === 'Bank Account' ? 'bank' : 'upi');

                if (formData.paymentDetails === 'Bank Account') {
                    if (formData.bankName) form.append('bankName', formData.bankName);
                    if (formData.bankAccount) form.append('accountNo', formData.bankAccount);
                    if (formData.bankIfsc) form.append('ifsc', formData.bankIfsc);
                }

                if (formData.paymentDetails === 'UPI' && formData.upiId) {
                    form.append('upiId', formData.upiId);
                }
            }

            // ✅ Append files conditionally
            if (formData.profileFile) {
                form.append('profile', formData.profileFile);
            }
            if (orgLogoFile && formData.userType !== 'employee') {
                form.append('logo', orgLogoFile);
            }

            try {
                const response = await axios.post(`${BaseURL}/invite/createUser`, form, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'inviteToken': inviteToken,
                    },
                });

                const { message, user } = response.data;

                toast.success(message || 'Registration successful!');

                localStorage.setItem('userId', user._id);
                localStorage.setItem('userType', user.type);
                localStorage.setItem('userName', user.userName);
                localStorage.setItem('email', user.email);

                setTimeout(() => {
                    navigate('/');
                }, 3000);
            } catch (error) {
                const errorMessage = error.response?.data?.message || 'Submission failed';
                toast.error(errorMessage);
            }
        }
    };



    return (

        <div className={styles.profileContainersss}>
            {/* <div className={styles.logo}>
                <img src={Logo} alt="Logo" />
            </div> */}
            <div className={styles.profileContainer}>
                <div className={styles.logoset}>
                    <img src={Logo} alt="Logo" />
                </div>
                <h2 className={styles.title}>Setup Your Profile</h2>

                <div className={styles.card}>
                    <div className={styles.header}>
                        <h3 className={styles.Heading}>👤 Basic Information</h3>
                    </div>
                    <div className={styles.imageSection}>
                        <div className={styles.Dflex}>
                            <div className={styles.imageContainer}>
                                <img src={profileImage} alt="profile" className={styles.profileImage} />
                                <div>
                                    <label htmlFor="imageInput" className={styles.changeImageButton}>Change Image</label>
                                    <input id="imageInput" type="file" accept="image/*" onChange={handleImageChange} style={{ display: 'none' }} />
                                    <p className={styles.imageInfo}>Upload image below 2MB (JPG, PNG)</p>
                                </div>
                            </div>
                            <div className={styles.inputGroupheaders}>
                                {/* <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>User Type</label>
                                    <input
                                        type="text"
                                        value={formData.userType}
                                        name="userType"
                                        className={styles.input}
                                        disabled
                                    />
                                </div> */}
                                <label className={styles.inputLabel}>User Type : </label>
                                <div className={styles.inputLabel}>{formData.userType || "-"}</div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.content}>
                        <div className={styles.formSection}>
                            {/* First and Last Name */}
                            <div className={styles.inputGroupheader}>
                                {['firstName', 'lastName'].map((field) => (
                                    <div className={styles.inputGroup} key={field}>
                                        <label className={styles.inputLabel}>{field === 'firstName' ? 'First Name' : 'Last Name'}</label>
                                        <input
                                            type="text"
                                            name={field}
                                            value={formData[field]}
                                            onChange={handleChange}
                                            placeholder={field === 'firstName' ? 'First Name' : 'Last Name'}
                                            className={styles.input}
                                            onKeyDown={(e) => e.target.selectionStart === 0 && e.key === ' ' && e.preventDefault()}
                                        />
                                        {errors[field] && <span className={styles.error}>{errors[field]}</span>}
                                    </div>
                                ))}
                            </div>

                            {/* Email and Phone */}
                            <div className={styles.inputGroupheader}>
                                <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>Email ID</label>
                                    <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Email ID" className={styles.input} />
                                    {errors.email && <span className={styles.error}>{errors.email}</span>}
                                </div>
                                <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>Phone Number</label>
                                    <input type="text" name="phone" value={formData.phone} onChange={handleChange} maxLength="10" placeholder="Phone Number" className={styles.input} />
                                    {errors.phone && <span className={styles.error}>{errors.phone}</span>}
                                </div>
                            </div>

                            {/* Username and Password */}
                            <div className={styles.inputGroupheader}>
                                <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>User Name</label>
                                    <input type="text" name="userName" value={formData.userName} onChange={handleChange} placeholder="User Name" className={styles.input} />
                                    {errors.userName && <span className={styles.error}>{errors.userName}</span>}
                                </div>
                                <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>Password</label>
                                    <input type="password" name="password" value={formData.password} onChange={handleChange} placeholder="Password" className={styles.input} />
                                    {errors.password && <span className={styles.error}>{errors.password}</span>}
                                </div>
                                <div className={styles.inputGroup}>
                                    <label className={styles.inputLabel}>Confirm Password</label>
                                    <input
                                        type="password"
                                        name="confirmPassword"
                                        value={formData.confirmPassword}
                                        onChange={handleChange}
                                        placeholder="Confirm Password"
                                        className={styles.input}
                                    />
                                    {errors.confirmPassword && <span className={styles.error}>{errors.confirmPassword}</span>}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {/* Address Information */}

                {formData.userType !== 'employee' && (
                    <div className={styles.card}>
                        <div className={styles.header}>
                            <h3 className={styles.Heading}>🏢 Address Information</h3>
                        </div>
                        <div className={styles.content}>
                            <div className={styles.formSection}>

                                <div className={styles.inputGroupheader}>
                                    <div className={styles.imageContainer}>
                                        <img src={orgLogoPreview} alt="profile" className={styles.profileImage} />
                                        <div style={{ marginTop: "20px" }} >

                                            <label htmlFor="orgLogoInput" className={styles.changeImageButton}>
                                                Upload Org Logo
                                            </label>
                                            <input
                                                id="orgLogoInput"
                                                type="file"
                                                accept="image/*"
                                                onChange={handleOrgLogoChange}
                                                style={{ display: 'none' }}
                                            />
                                            <p className={styles.imageInfo}>Upload image below 2MB (JPG, PNG)</p>
                                        </div>

                                    </div>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>Organization Name</label>
                                        <input
                                            type="text"
                                            name="organizationName"
                                            value={formData.organizationName}
                                            onChange={handleChange}
                                            placeholder="Organization Name"
                                            className={styles.input}
                                        />
                                        {errors.organizationName && <span className={styles.error}>{errors.organizationName}</span>}
                                    </div>

                                </div>

                                <div className={styles.inputGroupheader}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>Address 1</label>
                                        <input
                                            type="text"
                                            name="personalAddress"
                                            value={formData.personalAddress}
                                            onChange={handleChange}
                                            placeholder="Address Line 1"
                                            className={styles.input}
                                        />
                                        {errors.personalAddress && <span className={styles.error}>{errors.personalAddress}</span>}
                                    </div>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>City</label>
                                        <input
                                            type="text"
                                            name="address2"
                                            value={formData.address2 || ''}
                                            onChange={handleChange}
                                            placeholder="Address Line 2"
                                            className={styles.input}
                                        />
                                        {errors.address2 && <span className={styles.error}>{errors.address2}</span>}
                                    </div>

                                </div>

                                <div className={styles.inputGroupheader}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>Pincode</label>
                                        <input
                                            type="number"
                                            name="pincode"
                                            value={formData.pincode || ''}
                                            onChange={async (e) => {
                                                const pin = e.target.value;
                                                if (/^\d{6}$/.test(pin)) {
                                                    try {
                                                        const res = await fetch(`https://api.postalpincode.in/pincode/${pin}`);
                                                        const json = await res.json();
                                                        const postOffice = json?.[0]?.PostOffice?.[0];
                                                        if (postOffice) {
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                pincode: pin,
                                                                city: postOffice.District,
                                                                state: postOffice.State,
                                                            }));
                                                        } else {
                                                            toast.warn('Invalid Pincode');
                                                        }
                                                    } catch {
                                                        toast.error('Failed to fetch address');
                                                    }
                                                }
                                                setFormData(prev => ({ ...prev, pincode: pin }));
                                            }}
                                            placeholder="Pincode"
                                            className={styles.input}
                                        />
                                        {errors.pincode && <span className={styles.error}>{errors.pincode}</span>}
                                    </div>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>District</label>
                                        <input
                                            type="text"
                                            name="city"
                                            value={formData.city || ''}
                                            onChange={handleChange}
                                            className={styles.input}
                                            disabled
                                        />
                                    </div>

                                </div>

                                <div className={styles.inputGroupheader}>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>State</label>
                                        <input
                                            type="text"
                                            name="state"
                                            value={formData.state || ''}
                                            onChange={handleChange}
                                            className={styles.input}
                                            disabled
                                        />
                                    </div>
                                    <div className={styles.inputGroup}>
                                        <label className={styles.inputLabel}>GST</label>
                                        <input
                                            type="text"
                                            name="gst"
                                            value={formData.gst}
                                            onChange={handleChange}
                                            placeholder="GST"
                                            className={styles.input}
                                        />
                                        {errors.gst && <span className={styles.error}>{errors.gst}</span>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Payment Info */}
                {/* <div className={styles.card}>
                    <div className={styles.header}>
                        <h3>💳 Payment Information</h3>
                    </div>

                    <div className={styles.inputGroupheaders}>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Payment Details</label>
                            <select name="paymentDetails" value={formData.paymentDetails} onChange={handleChange} className={styles.inputs}>
                                <option>Bank Account</option>
                                <option>UPI</option>
                            </select>
                        </div>
                    </div>

                    <h4 className={styles.subHead}>Bank Details</h4>
                    <div className={styles.inputGroupheader}>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Bank Name</label>
                            <input placeholder="Bank Name" type="text" name="bankName" value={formData.bankName} onChange={handleChange} className={styles.input} />
                            {errors.bankName && <span className={styles.error}>{errors.bankName}</span>}
                        </div>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Bank Account No</label>
                            <input placeholder="Bank Account No" type="password" name="bankAccount" value={formData.bankAccount} onChange={handleChange} className={styles.input} />
                            {errors.bankAccount && <span className={styles.error}>{errors.bankAccount}</span>}
                        </div>
                    </div>

                    <div className={styles.inputGroupheader}>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Bank IFSC</label>
                            <input placeholder="Bank IFSC" type="text" name="bankIfsc" value={formData.bankIfsc} onChange={handleChange} className={styles.input} />
                            {errors.bankIfsc && <span className={styles.error}>{errors.bankIfsc}</span>}
                        </div>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>Confirm Bank Account No</label>
                            <input placeholder="Confirm Bank Account No" type="number" name="confirmBankAccount" value={formData.confirmBankAccount} onChange={handleChange} className={styles.input} />
                            {errors.confirmBankAccount && <span className={styles.error}>{errors.confirmBankAccount}</span>}
                        </div>
                    </div>

                    <h4 className={styles.subHead}>UPI Details</h4>
                    <div className={styles.inputGroupheaders}>
                        <div className={styles.inputGroup}>
                            <label className={styles.inputLabel}>UPI ID</label>
                            <input placeholder="UPI Details" type="text" name="upiId" value={formData.upiId} onChange={handleChange} className={styles.input} />
                            {errors.upiId && <span className={styles.error}>{errors.upiId}</span>}
                        </div>
                    </div>
                </div> */}

                <div className={styles.buttonGroup}>
                    <button className={styles.cancelButton}>Cancel</button>
                    <button className={styles.saveButton} onClick={handleSubmit}>Save Changes</button>
                </div>
            </div>

        </div>

    );
};

export default UserProfile;




